<template>
    <div class="user-edit-profile-wrap">
        <div class="user-edit-profile-head">
            <h1 class="fs-17 bg-gray mb-20px p-3 radius-4 d-flex align-center justify-content-between">
                Edit Your Profile
            </h1>
        </div>

        <div class="user-edit-profile-form">
            <el-form label-position="top" v-model="userData">
                <div class="user-edit-profile-form-box mb-30px">
                    <h4 class="form-title">Public Information</h4>
                    <el-row>
                        <el-col :span="24">
                            <div class="user-edit-profile-image d-flex align-center gap-4 mb-30px">
                                <img :src="require('@/assets/images/team-1.png')" alt="">
                                <div class="user-upload-profile-btn-wrap">
                                    <el-upload
                                        v-model:file-list="fileList"
                                        class="upload-demo"
                                        action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
                                        multiple
                                        :limit="10"
                                    >
                                        <el-button class="btn theme-btn" size="large"><el-icon><Picture /></el-icon> Upload Photo</el-button>
                                        <template #tip>
                                            <p class="el-upload__tip">
                                                jpg/png files with a size less than 20MB.
                                            </p>
                                        </template>
                                    </el-upload>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :span="24" class="responsive-tablet-col-1">
                        <el-col :span="9">
                            <div class="user-edit-profile-left">

                                <el-form-item label="Full Name">
                                    <el-input v-model="userData.fullName" size="large" />
                                </el-form-item>
                                <el-form-item label="Display Name">
                                    <el-input  v-model="userData.displayName" size="large" />
                                </el-form-item>
                                <el-form-item label="Location">
                                    <el-input v-model="userData.location" size="large" />
                                </el-form-item>
                                <el-form-item label="Title">
                                    <el-input v-model="userData.title" size="large" />
                                </el-form-item>

                            </div>
                        </el-col>
                        <el-col :span="15">
                            <el-form-item label="Bio">
                                <div class="user-edit-bio">
                                    <tinymce id="userBio" v-model="userData.userBio"></tinymce>
                                </div>
                            </el-form-item>

                        </el-col>
                    </el-row>
                </div>

                <div class="user-edit-profile-form-box user-edit-profile-web-presence mb-30px">
                    <h4 class="form-title">Links</h4>
                    <el-row :span="24" class="responsive-tablet-col-2">
                        <el-col :span="8">
                            <el-form-item label="Website link">
                                <el-input v-model="userData.websiteLink" size="large" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Twitter link or username">
                                <el-input v-model="userData.twitterLink" size="large" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="GitHub link or username">
                                <el-input v-model="userData.githubLink" size="large" />
                            </el-form-item>
                        </el-col>

                    </el-row>
                </div>
                
                <el-row>
                    <el-col>
                        <el-button class="btn theme-btn user-profile-save-btn">Save Changes</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </div>
</template>

<script>
import tinymce from 'vue-tinymce-editor'
import { Picture } from '@element-plus/icons-vue'

export default {
    name: 'UserProfileEdit',
    components: {
        tinymce,
        Picture
    },
    data() {
        return {
            fileList: [],
            userData: {
                fullName: 'John Doe',
                displayName: 'Developer Tanbir',
                location: 'United State',
                title: 'Software Engineer',
                userBio: 'Full-stack WordPress Developer',
                websiteLink: 'example.com',
                twitterLink: 'exampleTwitter',
                githubLink: 'exampleGithub'
            }
        }
    }
}
</script>